import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import usePurchase from '@hook/alerts/use-purchase'
import useTools from '@hook/shared/use-tools'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
const ActionExcelAlertPurchaseExport: FC<ILayoutToolsExportAction> = () => {
  const { isDisabled } = useTools()
  const { exportData } = usePurchase()
  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      bgColor="white"
      _hover={{ bg: 'gray.400' }}
      isDisabled={isDisabled}
      onClick={exportData}
      icon={<GrDocumentCsv />}
    >
      Exportar para Tabela
    </MenuItem>
  )
}

export default ActionExcelAlertPurchaseExport
